/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageFeedDeclarations.defs.js'
export { main as default } from './authManageFeedDeclarations.defs.js'
